export default __webpack_public_path__ + "static/media/cyber-reflection.e334247f.jpg";